import { NavLink } from 'react-router-dom';
import '../navbar.scss';
import './reusableDropdown.scss';

type DropdownItem = {
  to: string;
  label: string;
};

type ReusableDropdownProps = {
  id: string;
  toggleText: string;
  items: DropdownItem[];
};

export const ReusableDropdown: React.FC<ReusableDropdownProps> = ({ id, toggleText, items = [] }) => {
  return (
    <div className="dropdown show">
      <a
        className="link-redesign dropdown-toggle"
        href="#"
        role="button"
        id={id}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {toggleText}
      </a>
      <ul className="dropdown-menu custom-dropdown-menu" aria-labelledby={id}>
        {items.map((item, index) => {
          return (
            <li key={index}>
              <NavLink activeClassName="" className="dropdown-item custom-dropdown-item" to={item.to}>
                {item.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
